import { fmt } from "@/lib/units";

// Read-only W&B loading sheet: mass / arm / moment per item + totals (departure state).
export default function WBDetailTable({ wb }) {
  const items = wb.items || [];
  const totalW = items.reduce((s, i) => s + (Number(i.weight) || 0), 0);
  const totalM = items.reduce((s, i) => s + (Number(i.moment) || 0), 0);
  const cg = totalW > 0 ? totalM / totalW : 0;
  return (
    <div className="overflow-x-auto rounded-lg border border-slate-800" data-testid="wb-detail-table">
      <table className="w-full min-w-[420px] border-collapse text-left font-mono-data text-xs">
        <thead>
          <tr className="border-b border-slate-700 bg-slate-950/60 text-[10px] uppercase tracking-wider text-slate-400">
            <th className="px-3 py-2">Élément</th>
            <th className="px-3 py-2 text-right">Masse (kg)</th>
            <th className="px-3 py-2 text-right">Levier (m)</th>
            <th className="px-3 py-2 text-right">Moment (kg·m)</th>
          </tr>
        </thead>
        <tbody>
          {items.map((it, i) => (
            <tr key={i} className={i % 2 ? "bg-slate-900/40" : "bg-slate-900/70"}>
              <td className="px-3 py-2 font-semibold text-slate-100">{it.name}</td>
              <td className="px-3 py-2 text-right text-slate-300">{fmt(it.weight, 1)}</td>
              <td className="px-3 py-2 text-right text-slate-300">{fmt(it.arm, 3)}</td>
              <td className="px-3 py-2 text-right text-slate-300">{fmt(it.moment, 1)}</td>
            </tr>
          ))}
          <tr className="border-t border-cyan-500/30 bg-cyan-500/5 font-bold text-cyan-200">
            <td className="px-3 py-2">Total (départ)</td>
            <td className="px-3 py-2 text-right">{fmt(totalW, 1)}</td>
            <td className="px-3 py-2 text-right">CG {fmt(cg, 3)}</td>
            <td className="px-3 py-2 text-right">{fmt(totalM, 1)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
